import { render, staticRenderFns } from "./LeoOrderDetailPay.vue?vue&type=template&id=07648a39&scoped=true&"
import script from "./LeoOrderDetailPay.vue?vue&type=script&lang=js&"
export * from "./LeoOrderDetailPay.vue?vue&type=script&lang=js&"
import style0 from "./LeoOrderDetailPay.vue?vue&type=style&index=0&id=07648a39&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07648a39",
  null
  
)

export default component.exports